var window_active = false;
var notificationArray = [];

jQuery.validator.setDefaults({
    highlight: function (element, errorClass, validClass) {
        if (element.type === 'radio') {
            this.findByName(element.name).addClass(errorClass).removeClass(validClass);
        } else {
            $(element).addClass(errorClass).removeClass(validClass);
            $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
        }
    },
    unhighlight: function (element, errorClass, validClass) {
        if (element.type === 'radio') {
            this.findByName(element.name).removeClass(errorClass).addClass(validClass);
        } else {
            $(element).removeClass(errorClass).addClass(validClass);
            $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
        }
    }
});
jQuery.validator.unobtrusive.adapters.add(
    'requiredif', ['other'], function (options) {

        var getModelPrefix = function (fieldName) {
            return fieldName.substr(0, fieldName.lastIndexOf('.') + 1);
        }

        var appendModelPrefix = function (value, prefix) {
            if (value.indexOf('*.') === 0) {
                value = value.replace('*.', prefix);
            }
            return value;
        }

        var prefix = getModelPrefix(options.element.name),
            other = options.params.other,
            fullOtherName = appendModelPrefix(other, prefix),
            element = $(options.form).find(':input[name="' + fullOtherName + '"]')[0];

        options.rules['requiredif'] = element;
        if (options.message) {
            options.messages['requiredif'] = options.message;
        }
    }
);

$(window).focus(function () {
    window_active = true;
});

$(window).blur(function () {
    window_active = false;
});
$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip({ html: true })
    CheckPageVisibility();
    ApplyFormValidationClasses();
});
$(document).ajaxComplete(function () {
    $('[data-toggle="tooltip"]').tooltip({ html: true })
    ApplyFormValidationClasses();
});

function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var trident = ua.indexOf('Trident/');

    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    if (trident > 0) {
        // IE 11 (or newer) => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;
}



function promiseTimeout(ms, promise) {
    // Create a promise that rejects in <ms> milliseconds
    var timeout = new Promise(function (resolve, reject) {
        var id = setTimeout(function () {
            clearTimeout(id);
            reject('Timed out in ' + ms + 'ms.');
        }, ms)
    })

    // Returns a race between our timeout and the passed in promise
    return Promise.race([
        promise,
        timeout
    ])
}

function GetTheServiceWorker() {
    try {
        var baseURL = document.getElementsByTagName('base')[0].href;
        return navigator.serviceWorker.register(baseURL + 'sw.js', { scope: baseURL });
    } catch (e) {
        console.log("An error occurred while registering the service worker. ", e);
    }
   
}

function IsPageVisible() {
    return window_active;
}

function CheckPageVisibility() {
    var hidden = "hidden";

    // Standards:
    if (hidden in document)
        document.addEventListener("visibilitychange", onchange);
    else if ((hidden = "mozHidden") in document)
        document.addEventListener("mozvisibilitychange", onchange);
    else if ((hidden = "webkitHidden") in document)
        document.addEventListener("webkitvisibilitychange", onchange);
    else if ((hidden = "msHidden") in document)
        document.addEventListener("msvisibilitychange", onchange);
    // IE 9 and lower:
    else if ("onfocusin" in document)
        document.onfocusin = document.onfocusout = onchange;
    // All others:
    else
        window.onpageshow = window.onpagehide
            = window.onfocus = window.onblur = onchange;

    function onchange(evt) {
        var v = "visible", h = "hidden",
            evtMap = {
                focus: v, focusin: v, pageshow: v, blur: h, focusout: h, pagehide: h
            };

        evt = evt || window.event;
        if (evt.type in evtMap) {
            window_active = evtMap[evt.type] === "visible";
        } else {
            window_active = this[hidden] ? false : true;
        }
    }

    // set the initial state (but only if browser supports the Page Visibility API)
    if (document[hidden] !== undefined)
        onchange({ type: document[hidden] ? "blur" : "focus" });
}

function ShowTabNotification(show) {
    var notification = "🔴 ";
    var offTitle = document.title.replace(notification, "");
    var onTitle = notification + offTitle;
    if (show) {
        if (document.title !== onTitle) {
            document.title = onTitle;
        }
    } else {
        if (document.title !== offTitle) {
            document.title = offTitle;
        }
    }
}

function PrintElement(element, title, myCallBack) {
    $(element).print({
        globalStyles: true,
        noPrintSelector: ".hidden-print",
        iframe: true,
        title: title,
        deferred: $.Deferred().done(myCallBack),
        doctype: '<!doctype html>'
    });
}

function AreAudioNotificationsEnabled() {
    return LoadDataSafe('audio_notifications', true);
}

function ArePopupNotificationsEnabled() {
    return LoadDataSafe('visible_notifications', true) && AreBrowserNotificationsEnabled();
}

function SetNotificationSettingStatus() {
    var popupEnabled = ArePopupNotificationsEnabled();
    var audioEnabled = AreAudioNotificationsEnabled();
    $('#noti_nav_button_visual  input[type=checkbox]').prop("checked", popupEnabled);
    if (!popupEnabled) {
        $('#noti_nav_button_sound').prop("disabled", true);
        $('#noti_nav_button_sound').addClass("hidden");
    } else {
        $('#noti_nav_button_sound').prop("disabled", false);
        $('#noti_nav_button_sound').removeClass("hidden");
    }
    $('#noti_nav_button_sound input[type=checkbox]').prop("checked", audioEnabled && popupEnabled);

    $('#noti_nav_button .fa').removeClass('text-green');
    $('#noti_nav_button .fa').removeClass('text-orange');
    $('#noti_nav_button .fa').removeClass('text-red');
    $('#noti_nav_button .fa').removeClass('fa-bell');
    $('#noti_nav_button .fa').removeClass('fa-bell-slash');
    if (audioEnabled && popupEnabled) {
        $('#noti_nav_button .fa').addClass('text-green');
        $('#noti_nav_button .fa').addClass('fa-bell');
    } else if (audioEnabled || popupEnabled) {
        $('#noti_nav_button .fa').addClass('text-orange');
        $('#noti_nav_button .fa').addClass('fa-bell');
    } else {
        $('#noti_nav_button .fa').addClass('text-red');
        $('#noti_nav_button .fa').addClass('fa-bell-slash');
    }
}

function SetupSwitches() {
    $('[data-toggle="switch"]').each(function () {
        $(this).click(function (event) {
            var checkbox = $(this).find('input');
            event.preventDefault()
            event.stopImmediatePropagation()
            checkbox.prop("checked", !checkbox.is(':checked'));
            checkbox.change();
        });
    });
}

function SetAudioNotifications(value) {
    SaveData('audio_notifications', value === true);
}

function SetPopupNotifications(value) {
    var returnValue = value === true && AreBrowserNotificationsEnabled()
    SaveData('visible_notifications', returnValue);
    return returnValue;
}

function AreBrowserNotificationsEnabled() {
    if (DoesBrowserSupportNotifications()) {
        var notification = window.Notification || window.mozNotification || window.webkitNotification;
        return notification.permission !== 'denied' && notification.permission !== 'default';
    }
    return false;
}

function ApplyFormValidationClasses() {
    $("span.field-validation-valid, span.field-validation-error").addClass('help-block');
    $("div.form-group").has("span.field-validation-error").addClass('has-error');
    $("div.validation-summary-errors").has("li:visible").addClass("alert alert-block alert-danger");
}

function EnableBrowserNotifications() {
    var notification = window.Notification || window.mozNotification || window.webkitNotification;
    notification.requestPermission(function (permission) {
        //permission == 'granted'
        notification.permission = permission;
        if (permission === 'denied') {
            toastr.error("Please enable notification permissions for this site.");
        } else if (permission === 'granted') {
            SetPopupNotifications(true);
            SetAudioNotifications(true);
            refreshPage();
        }
        console.log(permission);
    });
    DismissPromptForNorifications();
}

function PromptForBrowserNotifications(override) {
    if (!AreBrowserNotificationsEnabled() && (!LoadData('prompted_for_notification', false) || override)) {
        $('#enable-notifications').modal('show');
        SaveData('prompted_for_notification', true);
    }
}

function DismissPromptForNorifications() {
    // SaveData('prompted_for_notification', true);
    if (LoadDataSafe("also_disable_sound", true)) {
        SaveData('also_disable_sound', false);
        SetAudioNotifications(false);
    }
    SetNotificationSettingStatus();
    $('#enable-notifications').modal('hide');
}

function NotifyForActivity(notificationID, title, subtitle, message, persistent, data, shouldShowPopup) {
    console.log("NotifyForActivity", arguments);
    if (shouldShowPopup) {
        ShowNotification(notificationID, title, subtitle, message, persistent, !AreAudioNotificationsEnabled(), data)
    }
}

function PlayNotificationSound() {
    var baseURL = document.getElementsByTagName('base')[0].href;
    var soundURL = baseURL + 'Content/sounds/default.wav';
    //$.playSound(soundURL);
    var audio = new Audio(soundURL);
    return audio.play();
}

function ShowNotificationBasic(notificationID, title, subtitle, message, persistent, silent, data) {
    console.log("ShowNotificationBasic");
    var baseURL = document.getElementsByTagName('base')[0].href;
    var iconURL = baseURL + 'favicon.ico';
    var titleText = title + '';
    if (titleText.length == 0) {
        titleText = 'RadNet Virtual Waiting Room';
    }
    if ('undefined' !== typeof (subtitle) && subtitle.length > 0) {
        titleText += '\n' + subtitle;
    }

    if ('undefined' === typeof (persistent)) {
        persistent = false;
    }

    if (AreBrowserNotificationsEnabled() && ArePopupNotificationsEnabled()) {

        var notification = window.Notification || window.mozNotification || window.webkitNotification;
        if ('undefined' === typeof (notification)) {
            return false;
        }
        CloseNotification(notificationID);
        newNotification = new notification(
            titleText, {
            body: message,
            dir: 'auto', // or ltr, rtl
            lang: 'EN', //lang used within the notification.
            tag: notificationID ? notificationID : 'notificationPopup', //An element ID to get/set the content,
            requireInteraction: persistent,
            silent: silent,
            renotify: true,
            icon: iconURL,
            data: data
        });
        notificationArray.push(newNotification);
        //console.log('@Url.Content("~/favicon.ico")');
        newNotification.onclick = function (event) {

        }
        newNotification.onerror = function (event) {
            console.log('notification.Error');
        };
        newNotification.onshow = function (event) {
            //   console.log(soundpath);
            console.log('notification.Show');
        };
        newNotification.onclose = function () {
            //   console.log('notification.Close');
        };
    }

    return true;
}

function ShowNotification(notificationID, title, subtitle, message, persistent, silent, data) {
    var baseURL = document.getElementsByTagName('base')[0].href;
    var iconURL = baseURL + 'favicon.ico';
    var titleText = title + '';
    if (titleText.length == 0) {
        titleText = 'RadNet Virtual Waiting Room';
    }
    if ('undefined' === typeof (notificationID) || !notificationID) {
        notificationID = 'notificationPopup';
    }
    if ('undefined' !== typeof (subtitle) && subtitle.length > 0) {
        titleText += '\n' + subtitle;
    }

    if ('undefined' === typeof (persistent)) {
        persistent = false;
    }
    if (AreBrowserNotificationsEnabled() && ArePopupNotificationsEnabled()) {
        try {
            GetTheServiceWorker()
                .then(function (registration) {
                    if (registration) {
                        registration.getNotifications({ tag: notificationID }).then(function (notificationsList) {
                            console.log("Current NotificationID notificaitons: ", notificationsList);
                            var unreadCount = 1;
                            if (notificationsList.length > 0) {
                                var existingSessionIDs = notificationsList[0].data.sessionIds;
                                var newSessionIDs = data.sessionIds;
                                console.log("Existing Data sessionIDs", existingSessionIDs);
                                console.log("New Data sessionIDs", newSessionIDs);

                                if (!notificationsList[0].data.sessionIds.includes(newSessionIDs[0])) {
                                    var sessionID = newSessionIDs[0];
                                    newSessionIDs = existingSessionIDs;
                                    newSessionIDs.push(sessionID);
                                } else {
                                    newSessionIDs = existingSessionIDs;
                                }
                                data.sessionIds = newSessionIDs;
                                console.log("FINAL Data sessionIDs", data.sessionIds);
                                unreadCount = data.sessionIds.length;
                            }
                            data.unreadCount = unreadCount;
                            if (unreadCount > 1) {
                                message = "You have " + unreadCount + " messages! Click here to read them.";
                            } else {
                                message = "You have a new message! Click here to read it.";
                            }
                            return registration.showNotification(titleText, {
                                body: message,
                                dir: 'auto', // or ltr, rtl
                                lang: 'EN', //lang used within the notification.
                                tag: notificationID, //An element ID to get/set the content,
                                requireInteraction: persistent,
                                silent: silent,
                                renotify: true,
                                icon: iconURL,
                                data: data,
                                actions: [{
                                    action: "open",
                                    title: "Read Message"
                                }
                                ]
                            });
                        });
                    }
                    else {
                        ShowNotificationBasic(title, subtitle, message, persistent, onClick);
                    }
                })
                .catch(function (err) { return alert('Service Worker registration error: ' + err); });
        } catch (err) {
            console.log("Service worker notification failed to load. Falling back on default notification.");
            ShowNotificationBasic(title, subtitle, message, persistent, onClick);
        }
    }
    return true;
}

function CloseNotification(notificationID) {
    if ('undefined' === typeof notificationArray || notificationArray === null)
        return false;
    else {
        var notificationIndex = notificationArray.findIndex(function (n) { return n.tag === notificationID })
        if (notificationIndex > -1) {
            var notificationToBeRemoved = notificationArray[notificationIndex];
            notificationToBeRemoved.close();
            notificationArray.splice(notificationIndex, 1);
        }
    }
    GetTheServiceWorker().then(function (registration) {
        registration.getNotifications().then(function (notificationsList) {
            for (var i = 0; i < notificationsList.length; i++) {
                if (notificationsList[i].tag === notificationID) {
                    notificationsList[i].close();
                }
            }
        });
    });

}

function CloseNotifications() {
    if ('undefined' === typeof noty || noty === null)
        return false;
    else
        noty.close();
}

function DoesBrowserSupportNotifications() {
    var notification = window.Notification || window.mozNotification || window.webkitNotification;
    return 'undefined' !== typeof (notification);
}

function LoadAjaxData(url, id, onLoaded, optionalErrorMsg) {
    if (id.indexOf('#') < 0) {
        id = '#' + id;
    }
    $.ajax({
        url: url
    }).fail(function (jqXHR, textStatus, errorThrown) {
        if (!optionalErrorMsg) {
            optionalErrorMsg = 'The data couldn\'t be loaded due to an error.';
        }
        $(id).html('<div class="alert alert-danger">' + optionalErrorMsg + '</div>');
    }).done(function (data) {
        $(id).html(data);
        if (typeof (onLoaded) === 'function') {
            onLoaded();
        }
        $('[data-toggle="tooltip"]').tooltip({ html: true })
    });
}

function GetAjax(url, onDone, optionalErrorMsg, onError) {
    $.ajax({
        url: url
    }).fail(function (jqXHR, textStatus, errorThrown) {
        if (!optionalErrorMsg) {
            optionalErrorMsg = 'The data couldn\'t be loaded due to an error.';
        }
        toastr.error(optionalErrorMsg);
        if (typeof (onError) === 'function') {
            onError(errorThrown);
        }
    }).done(function (data) {
        if (typeof (onDone) === 'function') {
            onDone(data);
        }
    });
}

function PostAjax(url, payload, onDone, optionalErrorMsg) {
    $.ajax({
        type: "POST",
        url: url,
        data: payload
    }).fail(function (jqXHR, textStatus, errorThrown) {
        if (!optionalErrorMsg) {
            optionalErrorMsg = 'The data couldn\'t be loaded due to an error.';
        }
        toastr.error(optionalErrorMsg);
    }).done(function (data) {
        if (typeof (onDone) === 'function') {
            onDone(data);
        }
    });
}

function filterData(text, selector, runBefore, runAfter) {
    if (typeof (runBefore) === 'function') {
        runBefore();
    }
    var list = $(selector);
    var textArray = !text || text.length == 0 ? [] : text.split("|");
    list.each(function () {
        if (textArray.length == 0) {
            $(this).show();
        } else {
            var currentRowText = $(this).not('a').text().toLowerCase();
            if (textArray.some(function (item) { return currentRowText.indexOf(item.toLowerCase()) > 0 })) {
                $(this).show();
            } else {
                $(this).hide();
            }
        }
    });
    if (typeof (runAfter) === 'function') {
        runAfter();
    }
}

function refreshPage() {
    window.location = window.location;
}

function SaveCachedFilter(filterConst, erase) {
    if (erase) {
        SaveData(filterConst, "");
    } else {
        SaveData(filterConst, $('#txtFilter').val());
    }
}

function LoadCachedFilter(filterConst) {
    var savedFilter = LoadDataSafe(filterConst, '');
    // erase cached filter after reading it.
    SaveCachedFilter(filterConst, true);
    if (savedFilter && savedFilter.length > 0) {
        $('#txtFilter').val(savedFilter);
        $('#txtFilter').addClass('selected');
        $('#txtFilter').keyup();
    }
}

function RefreshFilter() {
    var filter = $('#txtFilter').val();
    if (filter && filter.length > 0) {
        $('#txtFilter').addClass('selected');
        $('#txtFilter').keyup();
    }
}

// WRITE TO STORAGE

function SaveData(name, obj) {
    if (localStorage) {
        localStorage.setItem(name, JSON.stringify(obj));
    }
    else {
        console.log('Local Storage is not supported on this browser.');
    }
}

function LoadData(name) {
    var data;
    if (localStorage) {
        data = JSON.parse(localStorage.getItem(name));
    }
    else {
        console.log('Local Storage is not supported on this browser.');
    }
    return data;
}

function GetCachedData(name, dafault_data) {
    var data = LoadData(name);
    if (data === null || typeof (data) === "undefined") {
        return dafault_data;
    } else {
        return data;
    }
}

function CacheData(name, obj) {
    SaveData(name, obj);
}

function LoadDataFromCookie(name, dafault_data) {
    var data;
    if (Cookies) {
        data = Cookies.get(name);
        if (data === null || typeof (data) === "undefined") {
            return dafault_data;
        } else {
            return JSON.parse(data);
        }
    }
    else {
        console.log('Cookies are not supported on this browser.');
    }
    return data;
}

function SaveDataToCookie(name, obj) {
    if (Cookies) {
        Cookies.set(name, JSON.stringify(obj));
    }
    else {
        console.log('Cookies are not supported on this browser.');
    }
}

function LoadDataSafe(name, dafault_data) {
    var data;
    if (localStorage) {
        data = JSON.parse(localStorage.getItem(name));
        if (data === null || typeof (data) === "undefined") {
            return dafault_data;
        }
    }
    else {
        console.log('Local Storage is not supported on this browser.');
    }
    return data;
}

function insertAtCaret(areaId, text) {
    var txtarea = document.getElementById(areaId);
    if (!txtarea) {
        return;
    }

    var scrollPos = txtarea.scrollTop;
    var strPos = 0;
    var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
        "ff" : (document.selection ? "ie" : false));
    if (br == "ie") {
        txtarea.focus();
        var range = document.selection.createRange();
        range.moveStart('character', -txtarea.value.length);
        strPos = range.text.length;
    } else if (br == "ff") {
        strPos = txtarea.selectionStart;
    }

    var front = (txtarea.value).substring(0, strPos);
    var back = (txtarea.value).substring(strPos, txtarea.value.length);
    txtarea.value = front + text + back;
    strPos = strPos + text.length;
    if (br == "ie") {
        txtarea.focus();
        var ieRange = document.selection.createRange();
        ieRange.moveStart('character', -txtarea.value.length);
        ieRange.moveStart('character', strPos);
        ieRange.moveEnd('character', 0);
        ieRange.select();
    } else if (br == "ff") {
        txtarea.selectionStart = strPos;
        txtarea.selectionEnd = strPos;
        txtarea.focus();
    }

    txtarea.scrollTop = scrollPos;
}